export default "__VITE_ASSET__CM5qHqQ0__"